import { ContentItem } from "@at/design-system-patterns";

import {
  LeasingTechnicalSpecificationQuery_search_Search_advert_Advert,
  LeasingTechnicalSpecificationQuery_search_Search_advert_Advert_specification_Specification_techData_TechData_standardFeatures_Feature,
} from "../../query/__generated__/leasing-technical-specification.query";
import { getContentItemRowData } from "../get-content-item-row-data/get-content-item-row-data";

const capitalizeFirstLetter = (string: string) => {
  return string[0]?.toUpperCase() + string.slice(1).toLowerCase();
};

export const getStandardEquipmentData = (
  data:
    | LeasingTechnicalSpecificationQuery_search_Search_advert_Advert
    | undefined,
): ContentItem[] => {
  const advertData = data?.specification;

  const categories = [
    ...new Set(
      advertData?.techData?.standardFeatures
        ?.map((feature) => feature?.category)
        .filter((category): category is string => data != null),
    ),
  ];

  const standardEquipmentDataUnfiltered: (ContentItem | null)[] =
    categories.map((category) => {
      type StandardFeature =
        LeasingTechnicalSpecificationQuery_search_Search_advert_Advert_specification_Specification_techData_TechData_standardFeatures_Feature;
      const filteredStandardFeatures =
        advertData?.techData?.standardFeatures?.filter(
          (feature): feature is StandardFeature => feature != null,
        ) ?? [];
      return getContentItemRowData({
        rowHeading: capitalizeFirstLetter(category),
        array: filteredStandardFeatures
          .filter((feature) => feature?.category === category)
          ?.map((feature) => feature?.description ?? ""),
      });
    });

  const standardEquipmentData: ContentItem[] =
    standardEquipmentDataUnfiltered.filter(
      (data): data is ContentItem => data != null,
    );

  return standardEquipmentData;
};
